import styles from "./styles.module.scss";

export function Header() {
  return (
    <header className={styles.headerContainer}>
      <nav className={styles.headerContent}>
        <ul>
          <li>
            <a href="#sobre">sobre mim</a>
            <span></span>
          </li>
          <li>
            <a href="#experiencia">experiência</a>
            <span></span>
          </li>
          <li>
            <a href="#contato">contato</a>
            <span></span>
          </li>
        </ul>
      </nav>
    </header>
  );
}
